export default function SkeletonBar({ className = "" }) {
    return <div className={`animate-pulse rounded-md bg-slate-200/80 ${className}`.trim()} />;
}
